<template>
  <div
    id="reports"
    class="row"
  >
    <div class="col-12">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="reset"
        @keydown="form.onKeydown($event)"
      >
        <v-container grid-list-xl>
          <toolbar
            :title="title"
            :loading="form.busy"
            :buttons="buttons"
            @getDocuments="getDocuments"
            @downloadExcel="downloadExcel"
          />
          <v-layout
            :id="ref"
            class="wrap justify-space-around form-body"
          >
            <v-col lg="4" md="6" sm="6" cols="12">
              <v-select
                v-model="form.type_movement"
                :items="typeMovements"
                label="Tipo de Movimiento"
                :rules="[rules.required]"
                required
              />
            </v-col>
            <v-col lg="4" md="6" sm="6" cols="12">
              <DatetimePicker
                v-model="form.dateStart"
                label="Fecha de Inicio"
                :rules="[rules.required]"
                required
              ></DatetimePicker>
            </v-col>
            <v-col lg="4" md="6" sm="6" cols="12">
              <DatetimePicker
                v-model="form.dateEnd"
                label="Fecha de Fin"
                :rules="[rules.required]"
                required
                ></DatetimePicker>
            </v-col>
            <v-col lg="4" md="6" sm="6" cols="12">
              <v-text-field
                v-model="form.transaction_uuid"
                label="ID de Transacción"
                maxlength="50"
              />
            </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>

    <v-col
      v-if="dowloading"
      class="subtitle-1 text-center"
      cols="12"
    > Cargando por favor espere...
    </v-col>
    <v-progress-linear
      indeterminate
      background-color="success"
      color="yellow darken-2"
      height="10"
      v-if="dowloading"
      v-model="value"
      :active="show"
    ></v-progress-linear>
    <div class="col-12">
      <v-data-table
        v-if="documents != 0"
        :headers="headers"
        :items="documents"
        class="elevation-1"
      >
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Form from 'vform';
import DatetimePicker from '~/components/DatetimePicker';
import Toolbar from '~/components/Toolbar';
import 'vuetify/src/styles/main.sass';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'Reporte de Movientos de Folios' };
  },
  components: {
    DatetimePicker,
    Toolbar,
  },
  data: () => ({
    title: 'Reporte de Movimientos de Folios',
    form: new Form({
      account_number: '',
      transaction_uuid: '',
      cufe: '',
      ruc: '',
      type_movement: null,
      busy: false,
      dateStart: '',
      dateEnd: '',
    }),
    valid: false,
    typeMovements: [
      { value: '1', text: 'Entradas' },
      { value: '2', text: 'Salidas' },
      { value: '3', text: 'Transferencias' },
      { value: '4', text: 'Conversiones' },
    ],
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      numeric: (v) => /^([0-9])*$/.test(v) || 'El campo solo permite caracteres numericos.',
      format: (v) => /^(?=.*[0-9])/.test(v) || 'El campo solo permite caracteres numericos.',
      rucLength: (v) => ((v.length >= 5 && v.length <= 20) || v.length === 0) || 'El campo debe tener de 5 a 20 caracteres.',
      rucFormat: (v) => (/^(([P][E][-](([-]|[0-9]){1,17})|[N][-](([-]|[0-9]){1,18})|[E][-](([-]|[0-9]){1,18})|(([-]|[0-9]){5,20}))|(((([0-9]{1})[-][A][V][-](([-]|[0-9]){1,15}))|(([0-9]{2})[-][A][V][-](([-]|[0-9]){1,14})))|((([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,15}))|(([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,14}))|([N][T][-](([-]|[0-9]){1,14}))|(([0-9]{1,2})[-][P][I][-](([-]|[0-9]){1,14}))|([P][I][-](([-]|[0-9]){1,14}))|(([0-9]){1,2}[P][I][-](([-]|[0-9]){1,14})))))$/.test(v)
        || v.length === 0) || 'El campo debe tener un formato válido.',
    },
    allHeaders: [
      {
        text: 'ID de Transacción',
        value: 'transaction_uuid',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Número de Cuenta',
        value: 'account_number',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Folios',
        value: 'folios',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Descripción',
        value: 'description',
        align: 'left',
        sortable: true,
      },
    ],
    documents: 0,
    dowloading: false,
    buttons: [
      {
        id: 'save',
        icon: 'mdi-file-find',
        name: 'Generar Vista Previa',
        event: 'getDocuments',
        color: 'blue',
      },
      {
        id: 'cancel',
        icon: 'mdi-download',
        name: 'Descargar Excel',
        event: 'downloadExcel',
        color: 'green',
      },
    ],
  }),
  mounted() {
    this.form.dateStart = this.getStartDate();
    this.form.dateEnd = this.getEndDate();
  },
  methods: {
    getEndDate() {
        const date = new Date();
        const y = date.getFullYear();
        const m = (date.getMonth() + 1 < 10) ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const d = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
        const Hrs = (date.getHours() < 10) ? `0${date.getHours()}` : date.getHours();
        const Min = (date.getMinutes() < 10) ? `0${date.getMinutes()}` : date.getMinutes();
        const fecha = `${y}-${m}-${d} ${Hrs}:${Min}`;
        return fecha;
    },
    getStartDate() {
        const date = new Date();
        const y = date.getFullYear();
        const m = (date.getMonth() + 1 < 10) ? `0${date.getMonth()}` : date.getMonth();
        const d = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
        const Hrs = (date.getHours() < 10) ? `0${date.getHours()}` : date.getHours();
        const Min = (date.getMinutes() < 10) ? `0${date.getMinutes()}` : date.getMinutes();
        const fecha = `${y}-${m}-${d} ${Hrs}:${Min}`;
        return fecha;
    },
    getDocuments() {
      this.validate();
      if (this.$refs.form.validate()) {
        this.dowloading = true;
        // eslint-disable-next-line
        let value;
        [value, this.form.timeStart] = this.form.dateStart.split(' ');
        [value, this.form.timeEnd] = this.form.dateEnd.split(' ');
        const filteredFields = [];
        const url = '/api/reportOperation'; // Ruta que nos devuelva todos los datos del reporte
        this.form.post(url).then((response) => {
          this.documents = response.data.items; // creamos array & guardamos el contenido que nos devuelve el response
          this.headers = this.allHeaders;

          this.headers = this.headers.filter((header) => filteredFields.indexOf(header.text) === -1);
          setTimeout(() => { this.dowloading = false; }, 500);
        })
        .catch(() => {
        });
      }
    },

    downloadExcel() {
        if (!this.documents) {
          this.$store.dispatch('notifications/show', {
            message: 'El archivo Excel NO contiene registros que coincidan con los criterios de búsqueda.',
            type: 'error',
          });
        } else {
          this.dowloading = true;
          const url = '/api/download_excel_operations/export-operation';
          window.axios({
            method: 'post',
            url,
            responseType: 'arraybuffer',
            data: this.form,
          }).then((response) => {
              this.downloadFile(response, 'Reporte de Cuentas');

              setTimeout(() => { this.dowloading = false; }, 1000);
          })
          .catch(() => {
          });
        }
    },

    downloadFile(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xlsx`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.valid = true;
      }
    },

  },
};
</script>
